import BacktestNav from "./BacktestNav";
import BacktestStrategy from "./BacktestStrategy";
import { ResultLoader } from "./ResultLoader";
import BacktestRunBtn from "./BacktestRunBtn";

export default function BacktestRunForm() {
  return (
    <>
      <BacktestNav />
      <BacktestStrategy />
      <BacktestRunBtn />
      <ResultLoader />
    </>
  );
}
